import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ListPage.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
}

export default function NewsList() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/news/public?limit=100`)
      .then((res) => setNews(res.data.data || []))
      .catch(() => setNews([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="list-page">
      <nav className="list-page__nav">
        <Link to="/" className="list-page__back">← Beranda</Link>
      </nav>

      <h1 className="list-page__title">Semua Berita</h1>

      {loading ? (
        <p className="list-page__empty">Memuat...</p>
      ) : news.length === 0 ? (
        <p className="list-page__empty">Belum ada berita.</p>
      ) : (
        <div className="list-page__grid">
          {news.map((n) => (
            <Link to={`/news/${n.slug}`} className="list-card" key={n.id}>
              <div className="list-card__photo">
                {n.thumbnail_url ? (
                  <img src={n.thumbnail_url} alt={n.title} />
                ) : (
                  <div className="list-card__photo-fallback" />
                )}
              </div>
              <div className="list-card__body">
                <p className="list-card__date">{formatDate(n.published_at)}</p>
                <h3 className="list-card__title">{n.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
